import React, { Component } from "react";
import {
  loading,
  NavbarAdmin,
  Pagination,
  Modal,
  GET,
  POST,
  PUT,
  DELETE,
  UPLOAD,
  MAX_UPLOAD_SIZE,
  Select,
  DatePicker,
  alert,
  company,
  float,
  t,
  format_date
} from "../../components/CustomComponent.js";

export default class WorkRequests extends Component {
    constructor(props) {
        super(props);
        this.state = {
            company_id: company?.id || "", // จาก Header ที่ให้มา
            filter_search: "",
            hover_action: "",
            tab: "all",
            page: 1,
            page_size: 10,
            count: 0,
            data: [],
            summary_count: {
                pending: 0,
                success: 0,
                pending_approval: 0,
                approved: 0,
                rejected: 0,
                all: 0,
            },

            // Options from API
            data_customer: [],
            data_asset: [],
            data_reject_reasons: [],
            data_service_types: [],
            data_priorities: [],
            data_categories: [],
            data_technicians: [],

            // Modals
            modal_approve: false,
            modal_fast_call: false,
            modal_reject: false,
            modal_create: false,
            view_mode: false,
            fast_call_view_mode: false,
            reject_view_mode: false,
            active_request: null,

            // Reject Form States
            reject_reason_id: "",
            reject_note: "",
            fast_call_technician: "",
            fast_call_date: "",
            fast_call_time: "",
            fast_call_duration: 0,
            fast_call_channel: "โทรศัพท์ตรง",
            fast_call_symptom: "",
            fast_call_guidance: "",
            fast_call_result: "visit",

            // Create/Update Form States
            uid: "",
            create_customer_id: "",
            create_asset_id: "",
            create_contact_name_1: "",
            create_contact_phone_1: "",
            create_contact_name_2: "",
            create_contact_phone_2: "",
            create_contact_email: "",
            create_category_id: "",
            create_service_type_id: "",
            create_problem_desc: "",
            create_priority_id: "",
            create_internal_note: "",
            create_channel: "call",
            text_priority_id: "",

            select_asset: null,

            // Upload Files
            images: [],
            videos: [],

            // Mock Data สำหรับส่วนที่ยังไม่มี API (เช่น ช่าง)
            technicians: [{ name: "Somchai T.", initials: "ST", bg: "#198754", status: "Available Now", statusColor: "success", distance: "5.2 km away", bestMatch: true, tags: [], hint: "" }],
            wo_type: "Corrective Maintenance",
            wo_priority: "Emergency",
            sla_template: "Emergency SLA (1hr/4hr)",
        };
    }

    async componentDidMount() {
        loading(true);
        await this.GetOptions();
        await this.Get(1);
        loading(false);
    }

    getCreateFormState = () => ({
        uid: "",
        create_customer_id: "",
        create_asset_id: "",
        create_contact_name_1: "",
        create_contact_phone_1: "",
        create_contact_name_2: "",
        create_contact_phone_2: "",
        create_contact_email: "",
        create_category_id: "",
        create_service_type_id: "",
        create_problem_desc: "",
        create_priority_id: "",
        create_internal_note: "",
        create_channel: "call",
        text_priority_id: "",
        select_asset: null,
        images: [],
        videos: [],
        view_mode: false,
    });

    getFastCallFormState = () => {
        const now = new Date();
        const pad = (n) => String(n).padStart(2, "0");
        return {
            fast_call_technician: "",
            fast_call_date: `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`,
            fast_call_time: `${pad(now.getHours())}:${pad(now.getMinutes())}`,
            fast_call_duration: 0,
            fast_call_channel: "โทรศัพท์ตรง",
            fast_call_symptom: "",
            fast_call_guidance: "",
            fast_call_result: "",
        };
    };

    getCurrentLang = () => localStorage.getItem("lang") || "TH";

    getCustomerDisplayName = (customer) => {
        const currentLang = this.getCurrentLang();

        if (currentLang === "EN") {
            return `${customer?.customer_code || ""} ${customer?.full_name_en || customer?.full_name_th || customer?.name || "-"}`;
        }

        return `${customer?.customer_code || ""} ${customer?.full_name_th || customer?.full_name_en || customer?.name || "-"}`;
    };

    getAssetCustomerId = (asset) => {
        return asset?.customer?.uid || asset?.customer_id || asset?.customer_uid || asset?.owner_customer_id || "";
    };

    getAssetDisplayName = (asset) => {
        return asset?.part_name || asset?.part?.name || asset?.asset_name || asset?.name || "-";
    };

    getAssetLocationName = (asset) => {
        return asset?.location_name || asset?.location?.name || asset?.location?.location_name || "-";
    };

    getAssetWarrantyExpireDate = (asset) => {
        const warrantyDates = [
            ...(Array.isArray(asset?.customer_warranty) ? asset.customer_warranty.map((item) => item?.customer_warranty_expire_date) : []),
            asset?.customer_warranty_expire_date,
        ]
            .filter(Boolean)
            .map((date) => String(date).split("T")[0]);

        if (warrantyDates.length === 0) {
            return "";
        }

        return warrantyDates.reduce((latest, current) => {
            if (!latest) {
                return current;
            }

            return new Date(current) > new Date(latest) ? current : latest;
        }, "");
    };

    isWarrantyExpired = (expireDate) => {
        const raw = String(expireDate || "").trim();
        if (!raw) return true;
        const parsed = new Date(raw.split("T")[0]);
        if (isNaN(parsed.getTime())) return true;
        parsed.setHours(0, 0, 0, 0);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return parsed < today;
    };

    getReceivedMeta = (item) => {
        const receivedSource = item?.created_at || item?.receive_date || item?.received_at || item?.updated_at || "";
        if (!receivedSource) {
            return {
                receivedAgo: "-",
                receivedDate: "",
            };
        }

        const receivedDate = new Date(receivedSource);
        if (Number.isNaN(receivedDate.getTime())) {
            return {
                receivedAgo: "-",
                receivedDate: "",
            };
        }

        const now = new Date();
        const diffMs = Math.max(0, now.getTime() - receivedDate.getTime());
        const diffMinutes = Math.floor(diffMs / (1000 * 60));
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

        let receivedAgo = "-";
        if (diffDays > 0) {
            receivedAgo = `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
        } else if (diffHours > 0) {
            receivedAgo = `${diffHours} hr${diffHours > 1 ? "s" : ""} ago`;
        } else if (diffMinutes > 0) {
            receivedAgo = `${diffMinutes} min ago`;
        } else {
            receivedAgo = "Just now";
        }

        return {
            receivedAgo,
            receivedDate: String(receivedSource).split("T")[0],
        };
    };

    normalizeWorkRequestItem = (item) => {
        const normalizedAsset = item?.asset
            ? {
                  ...item.asset,
                  part_name: this.getAssetDisplayName(item.asset),
                  customer_warranty_expire_date: this.getAssetWarrantyExpireDate(item.asset),
                  location_name: this.getAssetLocationName(item.asset),
              }
            : null;
        const receivedMeta = this.getReceivedMeta(item);

        return {
            ...item,
            asset: normalizedAsset,
            ...receivedMeta,
        };
    };

    getFilteredAssetOptions = () => {
        const { data_asset, create_customer_id } = this.state;

        if (!create_customer_id) {
            return [];
        }

        return data_asset.filter((asset) => this.getAssetCustomerId(asset) === create_customer_id);
    };

    getPriorityDescription = (priorityItem) => {
        if (!priorityItem) {
            return "";
        }

        return `${priorityItem.name_th} - ${t("must_respond_within")} ${priorityItem.sla_response_time_start} - ${priorityItem.sla_response_time_end} ${priorityItem.sla_response_time_start_unit}`;
    };

    getTechnicianDisplayName = (technician) => {
        return `${technician?.technician_code || ""} ${
            [technician?.first_name_th, technician?.last_name_th].filter(Boolean).join(" ") ||
            [technician?.first_name_en, technician?.last_name_en].filter(Boolean).join(" ") || "-"
        }`;
    };

    // -----------------------------------
    // API Methods
    // -----------------------------------

    // ดึงข้อมูล Master Data สำหรับ Dropdown
    GetOptions = async () => {
        let [res_customer, res_asset, res_reject, res_service, res_priority, res_category, res_technicians] = await Promise.all([
            GET("admin/customers", { page: 0, page_size: 10000 }),
            GET("admin/assets", { page: 0, page_size: 10000 }),
            GET("admin/work-requisition/reject-reasons", { page: 0, page_size: 10000 }),
            GET("admin/work-requisition/service-types", { page: 0, page_size: 10000 }),
            GET("admin/work-requisition/priorities", { page: 0, page_size: 10000 }),
            GET("admin/work-requisition/categories", { page: 0, page_size: 10000 }),
            GET("admin/technicians", { page: 0, page_size: 10000 }),
        ]);

        this.setState({
            data_customer: res_customer?.data?.map((e) => ({ ...e, value: e.uid, label: this.getCustomerDisplayName(e) })) || [],
            data_asset:
                res_asset?.data?.map((e) => ({
                    ...e,
                    part_name: this.getAssetDisplayName(e),
                    customer_warranty_expire_date: this.getAssetWarrantyExpireDate(e),
                    location_name: this.getAssetLocationName(e),
                    value: e.uid,
                    label: [this.getAssetDisplayName(e), e.asset_code, e.serial_number].filter(Boolean).join(" - ") || this.getAssetLocationName(e) || "-",
                })) || [],
            data_reject_reasons: res_reject?.data?.map((e) => ({ ...e, value: e.uid, label: e.name_th })) || [],
            data_service_types: res_service?.data?.map((e) => ({ ...e, value: e.uid, label: e.name_th })) || [],
            data_priorities: res_priority?.data?.map((e) => ({ ...e, value: e.uid, label: e.name_th })) || [],
            data_categories: res_category?.data?.map((e) => ({ ...e, value: e.uid, label: e.name_th })) || [],
            data_technicians: res_technicians?.data || [],
        });
    };

    Get = async (page, selectedTab = this.state.tab) => {
        loading(true);
        const status = selectedTab === "all" ? "" : selectedTab;
        let [result, summaryResult] = await Promise.all([
            GET("admin/work-requisitions", {
                page_size: this.state.page_size,
                page: page,
                data_search: this.state.filter_search || "",
                type: "",
                status,
            }),
            GET("admin/work-requisitions", {
                page_size: 10000,
                page: 0,
                data_search: this.state.filter_search || "",
                type: "",
            }),
        ]);

        if (result?.status) {
            const summary_count = (summaryResult?.data || []).reduce(
                (acc, item) => {
                    const statusKey = (item.status || "").toLowerCase();
                    acc.all += 1;
                    if (statusKey === "pending") acc.pending += 1;
                    if (statusKey === "success") acc.success += 1;
                    if (statusKey === "pending_approval") acc.pending_approval += 1;
                    if (statusKey === "approved") acc.approved += 1;
                    if (statusKey === "rejected") acc.rejected += 1;
                    return acc;
                },
                { pending: 0, success: 0, pending_approval: 0, approved: 0, rejected: 0, all: 0 }
            );

            this.setState({
                data: (result.data || []).map((item) => this.normalizeWorkRequestItem(item)),
                count: result.pagination?.count || 0,
                page,
                tab: selectedTab,
                summary_count,
            });
        }
        loading(false);
    };

    CreateUpdate = async () => {
        const {
            uid,
            company_id,
            create_customer_id,
            create_asset_id,
            create_contact_name_1,
            create_contact_phone_1,
            create_contact_name_2,
            create_contact_phone_2,
            create_contact_email,
            create_channel,
            create_category_id,
            create_service_type_id,
            create_problem_desc,
            create_priority_id,
            create_internal_note,
            images,
            videos, // สำหรับจัดการไฟล์ถ้า API รองรับ Multipart
        } = this.state;

        if (!create_category_id || !create_priority_id || !create_problem_desc) {
            alert("", "warning", t("warning"), t("required_fields_missing"));
            return;
        }

        if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
            loading(true);

            // อัปโหลดไฟล์ทีละไฟล์ (presigned URL ยิงตรงเข้า S3 -> fallback base64) เพื่อนำ path กลับมาใส่ใน body
            // ก่อนบันทึกข้อมูล work-request ทั้งหมด
            const image_attachments = await this.uploadAttachments(images, "work-requisitions/images", "image");
            const video_attachments = await this.uploadAttachments(videos, "work-requisitions/videos", "video");

            if (image_attachments === null || video_attachments === null) {
                // มีไฟล์อัปโหลดไม่สำเร็จ (POST แสดง alert แล้ว) ยกเลิกการบันทึก
                loading(false);
                return;
            }

            const attachments = [...image_attachments, ...video_attachments];

            let body = {
                company_id: company_id,
                customer_id: create_customer_id,
                asset_id: create_asset_id,
                contact_name_1: create_contact_name_1,
                contact_phone_1: create_contact_phone_1,
                contact_name_2: create_contact_name_2,
                contact_phone_2: create_contact_phone_2,
                contact_email: create_contact_email,
                channel: create_channel,
                work_requisition_categories_id: create_category_id,
                work_requisition_service_types_id: create_service_type_id,
                problem_description: create_problem_desc,
                work_requisition_priorities_id: create_priority_id,
                work_requisition_reject_reasons_id: "",
                reject_description: "",
                status: "pending", // Default status
                internal_remark: create_internal_note,
                attachments: attachments,
                is_active: true,
            };

            let result = !uid ? await POST("admin/work-requisitions", body) : await PUT("admin/work-requisitions/" + uid, body);

            if (result?.status === true) {
                alert("#", "success");
                this.setState({ modal_create: false, ...this.getCreateFormState() });
                this.Get(this.state.page);
            } else {
                alert("", "warning", t("warning"), result?.message || t("error_occurred"));
            }
            loading(false);
        }
    };

    SubmitApprove = async () => {
        const { active_request, company_id } = this.state;

        if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
            loading(true);
            let body = {
                company_id: company_id,
                status: "approved",
                is_active: true,
                // ใส่ฟิลด์อื่นๆ เดิมเข้าไปด้วยหาก API บังคับ Require
            };

            let result = await PUT("admin/work-requisitions/" + active_request.uid, body);
            if (result?.status) {
                alert("#", "success");
                this.setState({ modal_reject: false });
                this.Get(this.state.page);
            } else {
                alert("", "warning", t("warning"), result?.message || t("error_occurred"));
            }
            loading(false);
        }
    };
    SubmitReject = async () => {
        const { active_request, reject_reason_id, reject_note, company_id } = this.state;

        if (!reject_reason_id) {
            alert("", "warning", t("warning"), t("reject_reason_required"));
            return;
        }

        loading(true);
        let body = {
            company_id: company_id,
            work_requisition_reject_reasons_id: reject_reason_id,
            reject_description: reject_note,
            status: "rejected",
            is_active: true,
            // ใส่ฟิลด์อื่นๆ เดิมเข้าไปด้วยหาก API บังคับ Require
        };

        let result = await PUT("admin/work-requisitions/" + active_request.uid, body);
        if (result?.status) {
            alert("#", "success");
            this.setState({ modal_reject: false });
            this.Get(this.state.page);
        } else {
            alert("", "warning", t("warning"), result?.message || t("error_occurred"));
        }
        loading(false);
    };

    Delete = async (id) => {
        if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
            loading(true);
            let result = await DELETE("admin/work-requisitions/" + id, null);
            if (result?.status) {
                alert("#", "success");
                this.Get(1);
            } else {
                alert("", "warning", t("warning"), result?.message || t("error_occurred"));
            }
            loading(false);
        }
    };

    componentWillUnmount() {
        // คืนหน่วยความจำ object URL ที่สร้างไว้สำหรับ preview
        [...(this.state.images || []), ...(this.state.videos || [])].forEach((item) => {
            if (item?.url && item.url.startsWith("blob:")) {
                URL.revokeObjectURL(item.url);
            }
        });
    }

    // -----------------------------------
    // File Helpers
    // -----------------------------------
    // แปลง File เป็น object สำหรับ preview พร้อม url ชั่วคราว
    mapFilesToItems = (files) =>
        Array.from(files).map((file) => ({
            file,
            name: file.name,
            size: file.size,
            type: file.type,
            url: URL.createObjectURL(file),
        }));

    // ตรวจขนาดไฟล์ก่อนเพิ่มเข้า state (กัน 413) — คืนเฉพาะไฟล์ที่ขนาดไม่เกิน
    // fileType: "image" | "video"
    filterValidFiles = (files, fileType) => {
        const max = MAX_UPLOAD_SIZE[fileType] || MAX_UPLOAD_SIZE.default;
        const arr = Array.from(files || []);
        const tooBig = arr.filter((f) => f.size > max);
        if (tooBig.length > 0) {
            const mb = Math.round(max / 1024 / 1024);
            alert("", "warning", t("warning"), `${t("file_too_large")} (${mb} MB): ${tooBig.map((f) => f.name).join(", ")}`);
        }
        return arr.filter((f) => f.size <= max);
    };

    // อัปโหลดไฟล์ทีละไฟล์ (presigned URL -> fallback base64) แล้วคืน array ของ attachment object
    // { uid?, file_path, file_name, file_type, mime_type, file_size }
    // คืนค่า null หากมีไฟล์ใดอัปโหลดไม่สำเร็จ
    uploadAttachments = async (items, folder, fileType) => {
        const uploaded = [];

        for (const item of items || []) {
            // ไฟล์ที่อัปโหลดแล้ว (กรณีดู/แก้ไข) ส่ง meta เดิมกลับไป ไม่ต้องอัปโหลดซ้ำ
            if (!item?.file && typeof item?.url === "string" && item.url.includes("://")) {
                uploaded.push({
                    uid: item.uid,
                    file_path: item.url,
                    file_name: item.name || null,
                    file_type: item.file_type || fileType,
                    mime_type: item.mime_type || null,
                    file_size: item.file_size ?? null,
                });
                continue;
            }

            // backstop: กันไฟล์ใหญ่เกินหลุดมาถึงขั้นอัปโหลด
            const max = MAX_UPLOAD_SIZE[fileType] || MAX_UPLOAD_SIZE.default;
            if (item?.file && item.file.size > max) {
                const mb = Math.round(max / 1024 / 1024);
                alert("", "warning", t("warning"), `${t("file_too_large")} (${mb} MB): ${item?.name || ""}`);
                return null;
            }

            const res = await UPLOAD(item.file, { folder });

            if (res?.status === true && res?.data?.file_path) {
                uploaded.push({
                    file_path: res.data.file_path,
                    file_name: item.name || res.data.file_name || null,
                    file_type: fileType,
                    mime_type: res.data.mime_type || item.type || null,
                    file_size: res.data.file_size ?? item.size ?? null,
                });
            } else {
                alert("", "warning", t("warning"), `${t("upload")} "${item?.name || ""}" ${t("fail")}`);
                return null;
            }
        }

        return uploaded;
    };

    // -----------------------------------
    // Drag and Drop Handlers
    // -----------------------------------
    handleDragOver = (e) => {
        e.preventDefault();
    };

    handleImageDrop = (e) => {
        e.preventDefault();
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const newFiles = Array.from(e.dataTransfer.files).filter((file) => file.type.startsWith("image/"));
            const newItems = this.mapFilesToItems(this.filterValidFiles(newFiles, "image"));
            this.setState((prevState) => ({ images: [...prevState.images, ...newItems] }));
            e.dataTransfer.clearData();
        }
    };

    handleVideoDrop = (e) => {
        e.preventDefault();
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const validFiles = this.filterValidFiles(
                Array.from(e.dataTransfer.files).filter((file) => file.type.startsWith("video/")),
                "video"
            );
            const currentCount = this.state.videos.length;
            const allowedNewFiles = validFiles.slice(0, 3 - currentCount); // จำกัด 3 คลิป

            if (validFiles.length > allowedNewFiles.length) {
                // สามารถใส่ Alert แจ้งเตือนอัปโหลดเกินได้ที่นี่
            }

            const newItems = this.mapFilesToItems(allowedNewFiles);
            this.setState((prevState) => ({ videos: [...prevState.videos, ...newItems] }));
            e.dataTransfer.clearData();
        }
    };

    removeImage = async (index) => {
        if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
        this.setState((prevState) => {
            let imgs = [...prevState.images];
            const [removed] = imgs.splice(index, 1);
            if (removed?.url && removed.url.startsWith("blob:")) URL.revokeObjectURL(removed.url);
            return { images: imgs };
        });
    };

    removeVideo = async (index) => {
        if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
        this.setState((prevState) => {
            let vids = [...prevState.videos];
            const [removed] = vids.splice(index, 1);
            if (removed?.url && removed.url.startsWith("blob:")) URL.revokeObjectURL(removed.url);
            return { videos: vids };
        });
    };

    // -----------------------------------
    // Helpers
    // -----------------------------------
    getPriorityStyle = (priorityName) => {
        const p = String(priorityName).toUpperCase();
        if (p.includes("EMERGENCY")) return { backgroundColor: "#dc3545", color: "#fff" };
        if (p.includes("HIGH")) return { backgroundColor: "#fd7e14", color: "#fff" };
        if (p.includes("MEDIUM")) return { backgroundColor: "#ffc107", color: "#fff" };
        return { backgroundColor: "#0d6efd", color: "#fff" };
    };

    getCategoryClass = (categoryName) => {
        const c = String(categoryName);
        if (c.includes("Corrective")) return "bg-secondary-light text-secondary";
        if (c.includes("Preventive")) return "bg-success-light text-success";
        return "bg-primary-light text-primary";
    };

    openViewModal = (request) => {
        this.openDetailModal(request);
    };

    // เปิด modal เดียวกับ create แต่เป็นโหมดดูอย่างเดียว (read-only) พร้อม preview ไฟล์แนบ
    openDetailModal = async (request) => {
        loading(true);
        const result = await GET("admin/work-requisitions", { uid: request?.uid });
        loading(false);

        if (result?.status !== true || !result?.data) {
            alert("", "warning", t("warning"), result?.message || t("no_data_found"));
            return;
        }

        const d = result.data;
        const attachments = Array.isArray(d.attachments) ? d.attachments : [];
        const toItem = (a) => ({
            uid: a.uid,
            name: a.file_name || "",
            url: a.file_path,
            file_type: a.file_type,
            mime_type: a.mime_type,
            file_size: a.file_size,
            is_uploaded: true,
        });

        const matchedPriority = this.state.data_priorities.find((p) => p.uid === d.priority?.uid);
        // ใช้ asset ฉบับเต็มจาก data_asset (มี location_name / warranty ที่คำนวณไว้แล้ว)
        // เพราะ asset ใน response ของ work-requisition ไม่มีฟิลด์เหล่านั้น
        const selectedAsset = this.state.data_asset.find((a) => a.uid === d.asset?.uid) || d.asset || null;

        this.setState({
            modal_create: true,
            view_mode: true,
            uid: d.uid,
            active_request: d,
            create_customer_id: d.customer?.uid || "",
            create_asset_id: d.asset?.uid || "",
            select_asset: selectedAsset,
            create_contact_name_1: d.contact_name_1 || "",
            create_contact_phone_1: d.contact_phone_1 || "",
            create_contact_name_2: d.contact_name_2 || "",
            create_contact_phone_2: d.contact_phone_2 || "",
            create_contact_email: d.contact_email || "",
            create_category_id: d.category?.uid || "",
            create_service_type_id: d.service_type?.uid || "",
            create_problem_desc: d.problem_description || "",
            create_priority_id: d.priority?.uid || "",
            text_priority_id: this.getPriorityDescription(matchedPriority),
            create_internal_note: d.internal_remark || "",
            create_channel: d.channel || "call",
            images: attachments.filter((a) => a.file_type === "image").map(toItem),
            videos: attachments.filter((a) => a.file_type === "video").map(toItem),
        });
    };
    openFastCallModal = (request) => {
        const defaultTechnicianId = "";
        this.setState({
            modal_fast_call: true,
            fast_call_view_mode: false,
            active_request: request,
            ...this.getFastCallFormState(),
            fast_call_technician: defaultTechnicianId,
        });
    };

    openViewFastCallModal = async (request) => {
        loading(true);
        const result = await GET("admin/work-requisitions", { uid: request?.uid });
        loading(false);

        if (result?.status !== true || !result?.data) {
            alert("", "warning", t("warning"), result?.message || t("no_data_found"));
            return;
        }

        const requestDetail = result.data;
        const callData = requestDetail?.fast_call || requestDetail?.call || requestDetail?.work_requisition_call || requestDetail?.latest_call;

        if (!callData) {
            alert("", "warning", t("warning"), t("no_data_found"));
            return;
        }

        const normalizedCallTime = String(callData?.call_time || "").replace(" ", "T").slice(0, 16);

        this.setState({
            modal_fast_call: true,
            fast_call_view_mode: true,
            active_request: requestDetail,
            fast_call_technician: callData?.technician_id || callData?.technician?.uid || "",
            fast_call_date: normalizedCallTime.slice(0, 10),
            fast_call_time: normalizedCallTime.slice(11, 16),
            fast_call_duration: callData?.call_duration || 0,
            fast_call_channel: callData?.call_channel || "โทรศัพท์ตรง",
            fast_call_symptom: callData?.detail_from_customer || "",
            fast_call_guidance: callData?.detail_solution || "",
            fast_call_result: callData?.status === "success" ? "closed" : "visit",
        });
    };
    openApproveModal = (request) => {
        this.setState(
            {
                active_request: request,
            },
            () => {
                this.SubmitApprove();
            }
        );
        //     const { data_priorities } = this.state;
        //     let i = data_priorities.find(e=>e.uid === request.priority?.uid);
        //     this.setState({
        //       modal_approve: true,
        //       active_request: request,
        //       create_category_id: request.category?.uid,
        //       create_service_type_id: request.service_type?.uid,
        //       create_priority_id: request.priority?.uid,
        //       text_priority_id: `${i.name_th} - ต้องตอบสนองภายใน ${i.sla_response_time_start} - ${i.sla_response_time_end} ${i.sla_response_time_start_unit}`
        //     });
    };

    getStatusBadgeClass = (status) => {
        const statusKey = (status || "").toLowerCase();

        if (statusKey === "pending") {
            return "bg-warning-light text-warning border border-warning";
        }
        if (statusKey === "pending_approval") {
            return "";
        }
        if (statusKey === "approved") {
            return "bg-info-light text-info border border-info";
        }
        if (statusKey === "success") {
            return "bg-success-light text-success border border-success";
        }
        if (statusKey === "cancel" || statusKey === "cancelled" || statusKey === "rejected") {
            return "bg-secondary-light text-secondary border border-secondary";
        }

        return "bg-light text-dark border";
    };

    renderActionIconButton = ({ actionKey, label, className, icon, onClick }) => {
        const isHovered = this.state.hover_action === actionKey;

        return (
            <div
                className="position-relative d-inline-flex"
                onMouseEnter={() => this.setState({ hover_action: actionKey })}
                onMouseLeave={() => this.setState({ hover_action: "" })}
            >
                <button
                    className={`${className} rounded-circle d-inline-flex align-items-center justify-content-center p-0`}
                    style={{ width: "34px", height: "34px" }}
                    aria-label={label}
                    onClick={onClick}
                >
                    <span className="icon">{icon}</span>
                </button>
                {isHovered && (
                    <span
                        className="position-absolute start-50 translate-middle-x px-2 py-1 rounded-3 text-white text-10 fw-bold shadow-sm"
                        style={{
                            bottom: "calc(100% + 8px)",
                            backgroundColor: "#111827",
                            whiteSpace: "nowrap",
                            zIndex: 20,
                            letterSpacing: "0.02em",
                        }}
                    >
                        {label}
                    </span>
                )}
            </div>
        );
    };

    openRejectModal = (request) => {
        this.setState({
            modal_reject: true,
            reject_view_mode: false,
            active_request: request,
            reject_reason_id: "",
            reject_note: "",
        });
    };

    openWorkOrderPage = (request) => {
        const workOrderNumber = request?.work_order?.wo_number || "";

        if (!workOrderNumber) {
            alert("", "warning", t("warning"), t("no_data_found"));
            return;
        }

        const queryParams = new URLSearchParams();
        queryParams.set("search", workOrderNumber);

        window.location.href = `/ad/work-orders?${queryParams.toString()}`;
    };

    viewRejectReason = (request) => {
        const rejectReasonId =
            request?.reject_reason?.uid ||
            request?.work_requisition_reject_reason?.uid ||
            request?.work_requisition_reject_reasons_id ||
            "";
        const rejectDescription = request?.reject_description || request?.reject_note || "";

        this.setState({
            modal_reject: true,
            reject_view_mode: true,
            active_request: request,
            reject_reason_id: rejectReasonId,
            reject_note: rejectDescription,
        });
    };

    openCreateModal = () => {
        this.setState({
            modal_create: true,
            ...this.getCreateFormState(),
        });
    };

    submitFastCall = async () => {
        const {
            company_id,
            active_request,
            fast_call_technician,
            fast_call_date,
            fast_call_time,
            fast_call_duration,
            fast_call_channel,
            fast_call_symptom,
            fast_call_guidance,
            fast_call_result,
            page,
        } = this.state;

        if (!fast_call_result) {
            alert("", "warning", t("warning"), t("call_result_required"));
            return;
        }

        if (!fast_call_technician || !active_request?.uid || !fast_call_date || !fast_call_time || fast_call_guidance === "") {
            alert("", "warning", t("warning"), t("required_fields"));
            return;
        }

        if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) {
            return;
        }

        loading(true);

        const body = {
            company_id: company_id,
            wr_id: active_request.uid,
            technician_id: fast_call_technician,
            call_time: fast_call_date && fast_call_time ? `${fast_call_date} ${fast_call_time}` : "",
            call_duration: Number(fast_call_duration),
            call_channel: fast_call_channel,
            detail_from_customer: fast_call_symptom,
            detail_solution: fast_call_guidance,
            status: fast_call_result === "closed" ? "success" : "pending_approval",
            is_active: true,
        };

        const result = await POST("admin/work-requisition/calls", body);

        if (result?.status === true) {
            this.setState({
                modal_fast_call: false,
                active_request: null,
                ...this.getFastCallFormState(),
            });
            await this.Get(page);
            await alert("#", "success");
        } else {
            alert("", "warning", t("warning"), result?.message || t("error_occurred"));
        }

        loading(false);
    };

    render() {
        const {
            data,
            count,
            filter_search,
            tab,
            modal_approve,
            modal_fast_call,
            fast_call_view_mode,
            active_request,
            technicians,
            wo_type,
            wo_priority,
            sla_template,
            modal_reject,
            reject_view_mode,
            reject_reason_id,
            reject_note,
            fast_call_technician,
            fast_call_date,
            fast_call_time,
            fast_call_duration,
            fast_call_channel,
            fast_call_symptom,
            fast_call_guidance,
            fast_call_result,
            select_asset,
            modal_create,
            view_mode,
            create_customer_id,
            create_asset_id,
            create_contact_name_1,
            create_contact_phone_1,
            create_contact_name_2,
            create_contact_phone_2,
            create_contact_email,
            create_category_id,
            create_service_type_id,
            create_problem_desc,
            create_priority_id,
            create_internal_note,
            images,
            videos,
            data_categories,
            data_priorities,
            data_reject_reasons,
            data_service_types,
            data_technicians,
            data_customer,
            data_asset,
            text_priority_id,
            summary_count,
        } = this.state;

        const fastCallTechnicianOptions =
            Array.isArray(data_technicians) && data_technicians.length > 0
                ? data_technicians.map((technician) => ({
                      value: technician.uid,
                      label: this.getTechnicianDisplayName(technician),
                  }))
                : [];
        const filteredAssetOptions = this.getFilteredAssetOptions();

        return (
            <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
                <NavbarAdmin />
                <div className="body p-4 mt-3">
                    {/* Header Section */}
                    <div className="mb-4">
                        <h3 className="fw-bold mb-1">{t("work_requests")}</h3>
                        <div className="text-secondary">{t("manage_incoming_service_requests")}</div>
                    </div>

                    {/* Top Filter Toolbar */}
                    <div className="rounded-4 bg-white p-3 mb-3 shadow-sm border-0">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div className="d-flex flex-wrap gap-2 flex-grow-1">
                                <div className="position-relative">
                                    <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary">{"\uf002"}</span>
                                    <input
                                        type="text"
                                        className="form-control ps-5 wpx-300"
                                        style={{ height: "38px" }}
                                        placeholder={t("search_requests")}
                                        value={filter_search}
                                        onChange={(e) => this.setState({ filter_search: e.target.value })}
                                    />
                                </div>
                                <div className="d-flex gap-2">
                                    <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                        {t("filter")}
                                    </button>
                                    <button className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.setState({ filter_search: "" }, () => this.Get(1))}>
                                        {t("clear_all")}
                                    </button>
                                </div>
                                {/* Filters */}
                            </div>
                            <div className="d-flex gap-2">
                                <button className="btn btn-primary px-3 fw-bold rounded-3 shadow-sm" onClick={this.openCreateModal}>
                                    <span className="me-2">+</span>
                                    {t("create_request")}
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Tabs Section */}
                    <div className="d-flex border-bottom mb-3 px-2 text-14">
                        <div
                            className={`py-3 px-3 ${tab === "all" ? "fw-bold text-primary" : "text-secondary"} pointer`}
                            style={{ borderBottom: tab === "all" ? "3px #1976D2 solid" : "" }}
                            onClick={() => {
                                this.Get(1, "all");
                            }}
                        >
                            {t("all_requests")} <span className="badge bg-danger rounded-pill ms-1 px-2">{summary_count.all}</span>
                        </div>
                        <div
                            className={`py-3 px-3 ${tab === "pending" ? "fw-bold text-primary" : "text-secondary"} pointer`}
                            style={{ borderBottom: tab === "pending" ? "3px #1976D2 solid" : "" }}
                            onClick={() => {
                                this.Get(1, "pending");
                            }}
                        >
                            {t("pending")}{" "}
                            <span className="badge rounded-pill ms-1 px-2 text-dark" style={{ backgroundColor: "#FFE58F" }}>
                                {summary_count.pending}
                            </span>
                        </div>
                        <div
                            className={`py-3 px-3 ${tab === "success" ? "fw-bold text-primary" : "text-secondary"} pointer`}
                            style={{ borderBottom: tab === "success" ? "3px #1976D2 solid" : "" }}
                            onClick={() => {
                                this.Get(1, "success");
                            }}
                        >
                            {t("success")}{" "}
                            <span className="badge rounded-pill ms-1 px-2 text-white" style={{ backgroundColor: "#22C55E" }}>
                                {summary_count.success}
                            </span>
                        </div>
                        <div
                            className={`py-3 px-3 ${tab === "pending_approval" ? "fw-bold text-primary" : "text-secondary"} pointer`}
                            style={{ borderBottom: tab === "pending_approval" ? "3px #1976D2 solid" : "" }}
                            onClick={() => {
                                this.Get(1, "pending_approval");
                            }}
                        >
                            {t("waiting_approval")}{" "}
                            <span className="badge rounded-pill ms-1 px-2 text-white" style={{ backgroundColor: "#8B5CF6" }}>
                                {summary_count.pending_approval}
                            </span>
                        </div>
                        <div
                            className={`py-3 px-3 ${tab === "approved" ? "fw-bold text-primary" : "text-secondary"} pointer`}
                            style={{ borderBottom: tab === "approved" ? "3px #1976D2 solid" : "" }}
                            onClick={() => {
                                this.Get(1, "approved");
                            }}
                        >
                            {t("approved")}{" "}
                            <span className="badge rounded-pill ms-1 px-2 fw-bold border" style={{ backgroundColor: "#BFDBFE", color: "#1D4ED8", borderColor: "#60A5FA" }}>
                                {summary_count.approved}
                            </span>
                        </div>
                        <div
                            className={`py-3 px-3 ${tab === "rejected" ? "fw-bold text-primary" : "text-secondary"} pointer`}
                            style={{ borderBottom: tab === "rejected" ? "3px #1976D2 solid" : "" }}
                            onClick={() => {
                                this.Get(1, "rejected");
                            }}
                        >
                            {t("rejected")}{" "}
                            <span className="badge rounded-pill ms-1 px-2 text-white" style={{ backgroundColor: "#9CA3AF" }}>
                                {summary_count.rejected}
                            </span>
                        </div>
                    </div>

                    {/* Table List Section */}
                    <div className="bg-white rounded-4 shadow-sm pb-2">
                        <div className="table-responsive">
                            <table className="table table-hover align-middle mb-0" style={{ minWidth: "1800px" }}>
                                <thead>
                                    <tr className="text-muted fw-bold text-12 border-bottom border-light text-uppercase">
                                        {/* <th className="px-3 pb-1 wpx-40">
                                            <input type="checkbox" className="form-check-input" />
                                        </th> */}
                                        <th className="py-3 border-0 wpx-150">{t("request_id")}</th>
                                        <th className="py-3 border-0 wpx-250">{t("customer_asset")}</th>
                                        <th className="py-3 border-0 wpx-300">{t("description")}</th>
                                        <th className="py-3 border-0 wpx-120">{t("priority")}</th>
                                        <th className="py-3 border-0 wpx-120">{t("category")}</th>
                                        <th className="py-3 border-0 wpx-100 text-center">{t("channel")}</th>
                                        <th className="py-3 border-0 wpx-180">{t("primary_contact")}</th>
                                        <th className="py-3 border-0 wpx-120">{t("sla_due")}</th>
                                        <th className="py-3 border-0 wpx-150">{t("received")}</th>
                                        <th className="py-3 border-0 wpx-180 ">{t("status")}</th>
                                        <th className="py-3 border-0 wpx-160">{t("actions")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={index} className="border-bottom border-light bg-white">
                                            {/* <td className="px-3 py-2 rounded-start" style={{ borderLeft: `4px solid ${item.borderColor}` }}>
                                                <input type="checkbox" className="form-check-input" />
                                            </td> */}

                                            <td className="text-nowrap">
                                                <a href="#" className="text-primary text-12 fw-bold text-decoration-none" onClick={() => this.openViewModal(item)}>
                                                    {item.wr_number}
                                                </a>
                                            </td>

                                            <td className="text-nowrap">
                                                <div className="fw-bold text-12 text-dark text-nowrap">{this.getCustomerDisplayName(item.customer)}</div>
                                                <div className="text-secondary text-12">{item.asset?.part_name || ""}</div>
                                            </td>

                                            <td className="text-nowrap">
                                                <div className="fw-bold text-12 text-dark text-wrap">
                                                    {String(item.problem_description || "").length > 40 ? `${String(item.problem_description || "").slice(0, 40)}...` : item.problem_description || "-"}
                                                </div>
                                                {item.attachments?.length > 0 && (
                                                    <div className="text-secondary text-12 mt-1">
                                                        <span className="text-12 icon me-1">{""}</span> {item.attachments.length}
                                                    </div>
                                                )}
                                            </td>

                                            <td className="text-nowrap">
                                                <span className="badge rounded-pill fw-normal px-2 py-1 text-12" style={this.getPriorityStyle(item.priority?.name_th)}>
                                                    {item.priority?.name_th || ""}
                                                </span>
                                            </td>

                                            <td className="text-nowrap">
                                                <span className={`badge rounded-pill fw-normal px-2 py-1 text-12 ${this.getCategoryClass(item.category?.name_th || "")}`}>
                                                    {item.category?.name_th || ""}
                                                </span>
                                            </td>

                                            <td className="py-2 text-secondary text-12 text-nowrap text-center">{item.channel}</td>

                                            <td className="text-nowrap">
                                                <div className="fw-bold text-dark text-12">{item.contact_name_1}</div>
                                                <small className="text-secondary">{item.contact_phone_1}</small>
                                            </td>

                                            <td className="text-nowrap">
                                                <div className="text-dark text-wrap text-12">
                                                    {item.asset?.customer_warranty_expire_date ? format_date(item.asset.customer_warranty_expire_date, "dd-mm-yyyy", "th") : "-"}
                                                </div>
                                            </td>

                                            <td className="text-nowrap">
                                                <div className="fw-bold text-dark text-12">{item.receivedAgo}</div>
                                                <div className="text-secondary text-12">{item.receivedDate ? format_date(item.receivedDate, "dd-mm-yyyy", "th") : "-"}</div>
                                            </td>

                                            <td className="text-nowrap">
                                                <span
                                                    className={`badge rounded-pill px-3 py-1 text-12 d-inline-flex align-items-center justify-content-center ${this.getStatusBadgeClass(item.status)}`}
                                                    style={item.status === "pending_approval" ? { backgroundColor: "#F3E8FF", color: "#7C3AED", border: "1px solid #C4B5FD" } : undefined}
                                                >
                                                    {item.status.replaceAll("_", " ").toUpperCase()}
                                                </span>
                                            </td>

                                            <td className="rounded-end text-start me-2">
                                                <div className="d-flex align-items-center gap-2 justify-content-start pe-3">
                                                {this.renderActionIconButton({
                                                    actionKey: `view-detail-${item.uid || index}`,
                                                    label: t("view"),
                                                    className: "btn btn-outline-primary",
                                                    icon: "",
                                                    onClick: () => this.openDetailModal(item),
                                                })}
                                                {item.status === "pending" ? (
                                                    <div className="d-flex align-items-center gap-2 justify-content-start pe-3">
                                                        {this.renderActionIconButton({
                                                            actionKey: `fast-call-${item.uid || index}`,
                                                            label: t("fast_call"),
                                                            className: "btn btn-outline-warning",
                                                            icon: "\uf095",
                                                            onClick: () => this.openFastCallModal(item),
                                                        })}
                                                        {this.renderActionIconButton({
                                                            actionKey: `reject-${item.uid || index}`,
                                                            label: t("reject"),
                                                            className: "btn btn-outline-danger",
                                                            icon: "\uf00d",
                                                            onClick: () => this.openRejectModal(item),
                                                        })}
                                                    </div>
                                                ) : item.status === "pending_approval" ? (
                                                    <div className="d-flex align-items-center gap-2 justify-content-start">
                                                        {this.renderActionIconButton({
                                                            actionKey: `approve-${item.uid || index}`,
                                                            label: t("approve"),
                                                            className: "btn btn-outline-success",
                                                            icon: "\uf00c",
                                                            onClick: () => this.openApproveModal(item),
                                                        })}
                                                        {this.renderActionIconButton({
                                                            actionKey: `reject-${item.uid || index}`,
                                                            label: t("reject"),
                                                            className: "btn btn-outline-danger",
                                                            icon: "\uf00d",
                                                            onClick: () => this.openRejectModal(item),
                                                        })}
                                                    </div>
                                                ) : item.status === "approved" ? (
                                                    this.renderActionIconButton({
                                                        actionKey: `view-wo-${item.uid || index}`,
                                                        label: t("view_wo"),
                                                        className: "btn btn-outline-info",
                                                        icon: "\uf06e",
                                                        onClick: () => this.openWorkOrderPage(item),
                                                    })
                                                ) : item.status === "success" ? (
                                                    this.renderActionIconButton({
                                                        actionKey: `view-fast-call-${item.uid || index}`,
                                                        label: t("view_fast_call"),
                                                        className: "btn btn-outline-success",
                                                        icon: "\uf095",
                                                        onClick: () => this.openViewFastCallModal(item),
                                                    })
                                                ) : item.status === "rejected" ? (
                                                    <div className="d-flex align-items-center gap-2 justify-content-start">
                                                        {this.renderActionIconButton({
                                                            actionKey: `view-reason-${item.uid || index}`,
                                                            label: t("view_reason"),
                                                            className: "btn btn-outline-secondary",
                                                            icon: "\uf06e",
                                                            onClick: () => this.viewRejectReason(item),
                                                        })}
                                                        {item.fast_call
                                                            ? this.renderActionIconButton({
                                                                  actionKey: `view-fast-call-${item.uid || index}`,
                                                                  label: t("view_fast_call"),
                                                                  className: "btn btn-outline-secondary",
                                                                  icon: "\uf095",
                                                                  onClick: () => this.openViewFastCallModal(item),
                                                              })
                                                            : null}
                                                    </div>
                                                ) : null}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
                        <Pagination count={Math.ceil(count / this.state.page_size) || 1} page={this.state.page} onChange={(_, page) => this.Get(page)} />
                    </div>
                </div>

                {/* ===================== CREATE WORK REQUEST MODAL ===================== */}
                <Modal size="lg" show={modal_create} onHide={() => this.setState({ modal_create: false, ...this.getCreateFormState() })} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg bg-light">
                    <Modal.Header className="bg-white border-bottom px-4 py-3 d-flex justify-content-between align-items-center" closeButton>
                        <div>
                            <h5 className="fw-bold mb-1 text-dark d-flex align-items-center">
                                <span className="icon me-2 text-secondary">{"\uf0ea"}</span>{" "}
                                {view_mode ? `${t("view")} ${active_request?.wr_number || ""}`.trim() : t("create_work_request")}
                            </h5>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="p-4" style={{ maxHeight: "75vh", overflowY: "auto", backgroundColor: "#F8F9FA" }}>
                      <fieldset disabled={view_mode} className="border-0 p-0 m-0" style={{ minWidth: 0 }}>
                        {/* Section 1: ข้อมูลลูกค้าและเครื่อง */}
                        <div className="mb-4">
                            <h6 className="fw-bold text-secondary mb-3 d-flex align-items-center text-14">
                                <span className="icon me-2 text-16">{"\uf007"}</span>
                                {t("customer_asset_info")}
                            </h6>
                            <div className="bg-white rounded-3 p-3 border ">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label className="form-label text-dark fw-bold text-14">
                                            {t("customer")} <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                            className="form-control"
                                            options={data_customer}
                                            onChange={(e, i) => {
                                                const customerPriorityId = i?.priority?.uid || i?.priority_id || "";
                                                const matchedPriority = this.state.data_priorities.find((priority) => priority.uid === customerPriorityId || priority.value === customerPriorityId);

                                                this.setState({
                                                    create_customer_id: e,
                                                    create_contact_name_1: ((i?.contact_first_name || "") + " " + (i?.contact_last_name || "")).trim(),
                                                    create_contact_phone_1: i?.contact_phone || "",
                                                    create_contact_email: i?.contact_email || "",
                                                    create_priority_id: customerPriorityId,
                                                    text_priority_id: this.getPriorityDescription(matchedPriority),
                                                    create_asset_id: "",
                                                    select_asset: null,
                                                });
                                            }}
                                            value={create_customer_id}
                                            placeholder={t("select_customer")}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label text-dark fw-bold text-14">
                                            {t("asset")} <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                            className="form-control"
                                            options={filteredAssetOptions}
                                            onChange={(e, i) => {
                                                this.setState({ create_asset_id: e, select_asset: i });
                                            }}
                                            value={create_asset_id}
                                            placeholder={t("select_asset")}
                                            isDisabled={!create_customer_id}
                                        />
                                    </div>
                                </div>

                                {/* Asset Info Box */}
                                {select_asset && (
                                    <div className="mt-3 bg-primary-light rounded-3 p-3 border border-primary" style={{ backgroundColor: "#EBF3FF", borderColor: "#B3D4FF" }}>
                                        <div className="d-flex align-items-start gap-2 text-14">
                                            <span className="icon text-primary">{"\uf05a"}</span>
                                            <div className="text-primary">
                                                <span className="fw-bold">Asset:</span> {this.getAssetDisplayName(select_asset)} <span className="mx-1">|</span>
                                                <span className="fw-bold">Serial No.:</span> {select_asset?.serial_number} <span className="mx-1">|</span>
                                                <span className="fw-bold">Warranty:</span>{" "}
                                                {select_asset?.customer_warranty_expire_date
                                                    ? this.isWarrantyExpired(select_asset.customer_warranty_expire_date)
                                                        ? `${t("out_of_warranty")} (${t("warranty_until")} ${format_date(select_asset.customer_warranty_expire_date, "dd-mm-yyyy", "th")})`
                                                        : `${t("under_warranty")} (${t("warranty_until")} ${format_date(select_asset.customer_warranty_expire_date, "dd-mm-yyyy", "th")})`
                                                    : "-"}{" "}
                                                <span className="mx-1">|</span>
                                                <span className="fw-bold">Location:</span> {this.getAssetLocationName(select_asset)}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Section 2: ข้อมูลผู้ติดต่อ */}
                        <div className="mb-4">
                            <h6 className="fw-bold text-secondary mb-3 d-flex align-items-center text-14">
                                <span className="icon me-2 text-16">{"\uf095"}</span>
                                {t("contact_info")}
                            </h6>
                            <div className="bg-white rounded-3 p-3 border ">
                                <div className="row g-3">
                                    <div className="col-md-8">
                                        <label className="form-label text-dark fw-bold text-14">
                                            {t("primary_contact")} <span className="text-danger">*</span>{" "}
                                            <span className="badge bg-light text-secondary fw-normal ms-1 border">{t("auto_from_customer")}</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control py-2 "
                                            placeholder={t("enter_primary_contact_name")}
                                            value={create_contact_name_1}
                                            onChange={(e) => this.setState({ create_contact_name_1: e.target.value })}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label text-white d-none d-md-block">&nbsp;</label>
                                        <input
                                            type="text"
                                            className="form-control py-2 "
                                            placeholder={t("enter_primary_contact_phone")}
                                            value={create_contact_phone_1}
                                            onChange={(e) => this.setState({ create_contact_phone_1: e.target.value })}
                                            disabled
                                        />
                                    </div>

                                    <div className="col-md-8 mt-3">
                                        <label className="form-label text-dark fw-bold text-14">{t("secondary_contact_optional")}</label>
                                        <input
                                            type="text"
                                            className="form-control py-2 "
                                            placeholder={t("enter_secondary_contact_name")}
                                            value={create_contact_name_2}
                                            onChange={(e) => this.setState({ create_contact_name_2: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-md-4 mt-md-3">
                                        <label className="form-label text-white d-none d-md-block">&nbsp;</label>
                                        <input
                                            type="text"
                                            className="form-control py-2 "
                                            placeholder={t("phone_number")}
                                            maxLength={10}
                                            value={create_contact_phone_2}
                                            onChange={(e) => {
                                                if (!float(e.target.value)) return;
                                                this.setState({ create_contact_phone_2: e.target.value });
                                            }}
                                        />
                                    </div>

                                    <div className="col-12 mt-3">
                                        <label className="form-label text-dark fw-bold text-14">{t("customer_email")}</label>
                                        <input
                                            type="email"
                                            className="form-control py-2  text-secondary"
                                            placeholder={t("customer_email")}
                                            value={create_contact_email}
                                            onChange={(e) => this.setState({ create_contact_email: e.target.value })}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 3: รายละเอียดปัญหา */}
                        <div className="mb-4">
                            <h6 className="fw-bold text-secondary mb-3 d-flex align-items-center text-14">
                                <span className="icon me-2">{"\uf0ad"}</span>
                                {t("problem_detail")}
                            </h6>
                            <div className="bg-white rounded-3 p-3 border ">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">
                                            {t("req_category")}
                                            <span className="text-danger"> *</span>
                                        </label>
                                        <Select
                                            className="form-control"
                                            placeholder={t("select_req_category")}
                                            options={data_categories}
                                            onChange={(e, i) => {
                                                this.setState({ create_category_id: e, create_service_type_id: i.service_type_default?.uid });
                                            }}
                                            value={create_category_id}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">
                                            {t("service_type")}
                                            <span className="text-danger"> *</span>
                                        </label>
                                        <Select
                                            className="form-control"
                                            placeholder={t("select_service_type")}
                                            options={data_service_types}
                                            onChange={(e, i) => {
                                                this.setState({ create_service_type_id: e });
                                            }}
                                            value={create_service_type_id}
                                        />
                                    </div>
                                    <div className="col-12 mt-3">
                                        <label className="form-label fw-bold">
                                            {t("problem_description")} <span className="text-danger">*</span>
                                        </label>
                                        <textarea
                                            className="form-control "
                                            rows="3"
                                            placeholder={t("describe_problem_detail")}
                                            value={create_problem_desc}
                                            onChange={(e) => this.setState({ create_problem_desc: e.target.value })}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 4: ความสำคัญ */}
                        <div className="mb-4">
                            <h6 className="fw-bold text-secondary mb-3">
                                <span className="icon me-2 text-warning">{"\uf0e7"}</span> {t("priority")}
                                <span className="badge bg-light text-secondary fw-normal ms-1 border">{t("auto_from_customer")}</span>
                                <span className="text-danger"> *</span>
                            </h6>
                            <div className="bg-white rounded-3 p-3 border">
                                <div className="row g-3">
                                    <div className="col-12 col-lg-6">
                                        <Select
                                            className="form-control"
                                            placeholder={t("select_priority")}
                                            options={data_priorities}
                                            onChange={(e, i) => {
                                                this.setState({
                                                    create_priority_id: e,
                                                    text_priority_id: this.getPriorityDescription(i),
                                                });
                                            }}
                                            value={create_priority_id}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <input type="text" className="form-control" value={text_priority_id} placeholder={t("priority")} disabled />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 5: ไฟล์แนบ (DRAG & DROP) */}
                        <div className="mb-4">
                            <h6 className="fw-bold text-secondary mb-3 d-flex align-items-center text-14">
                                <span className="icon me-2 text-16">{"\uf0c6"}</span> {t("attachment_files")}
                            </h6>
                            <div className="bg-white rounded-3 p-3 border ">
                                {/* Images Dropzone */}
                                <label className="form-label text-dark fw-bold text-14 mb-2">{t("images")}</label>
                                {!view_mode && (
                                <div
                                    className="border rounded-3 p-4 mb-3 text-center pointer"
                                    style={{ borderStyle: "dashed", borderColor: "#ccc", backgroundColor: "#fafafa" }}
                                    onDragOver={this.handleDragOver}
                                    onDrop={this.handleImageDrop}
                                    onClick={() => document.getElementById("img-upload").click()}
                                >
                                    <input
                                        type="file"
                                        id="img-upload"
                                        multiple
                                        accept="image/*"
                                        hidden
                                        onChange={(e) => {
                                            const newItems = this.mapFilesToItems(this.filterValidFiles(e.target.files, "image"));
                                            this.setState((prev) => ({ images: [...prev.images, ...newItems] }));
                                            e.target.value = "";
                                        }}
                                    />
                                    <span className="icon text-30 text-success mb-2 d-block">{"\uf03e"}</span>
                                    <div className="fw-bold text-dark text-14">{t("click_or_drag_image_here")}</div>
                                </div>
                                )}

                                {/* Preview Images */}
                                <div className="d-flex flex-wrap gap-2 mb-4">
                                    {images.map((img, i) => (
                                        <div key={i} className="border rounded-3 p-2 text-center position-relative bg-light wpx-100">
                                            {!view_mode && (
                                            <div
                                                className="position-absolute top-0 end-0 bg-danger text-white rounded-circle wpx-15 hpx-15 d-flex align-items-center justify-content-center pointer"
                                                style={{ transform: "translate(30%, -30%)", zIndex: 2 }}
                                                onClick={() => this.removeImage(i)}
                                            >
                                                <span className="icon text-10">{"\uf00d"}</span>
                                            </div>
                                            )}
                                            <a href={img.url} target="_blank" rel="noopener noreferrer">
                                                <img
                                                    src={img.url}
                                                    alt={img.name}
                                                    className="rounded-2 mb-1"
                                                    style={{ width: "100%", height: "70px", objectFit: "cover" }}
                                                />
                                            </a>
                                            <div className="text-10 text-secondary text-truncate" title={img.name}>{img.name}</div>
                                        </div>
                                    ))}
                                </div>

                                {/* Videos Dropzone */}
                                <label className="form-label text-dark fw-bold text-14 mb-2">{t("videos_max_3")}</label>
                                {!view_mode && (
                                <div
                                    className="border rounded-3 p-4 mb-3 text-center pointer"
                                    style={{ borderStyle: "dashed", borderColor: "#fd7e14", backgroundColor: "#fff8f3" }}
                                    onDragOver={this.handleDragOver}
                                    onDrop={this.handleVideoDrop}
                                    onClick={() => document.getElementById("vid-upload").click()}
                                >
                                    <input
                                        type="file"
                                        id="vid-upload"
                                        multiple
                                        accept="video/mp4,video/quicktime"
                                        hidden
                                        onChange={(e) => {
                                            const files = this.filterValidFiles(e.target.files, "video");
                                            const allowed = files.slice(0, 3 - videos.length);
                                            const newItems = this.mapFilesToItems(allowed);
                                            this.setState((prev) => ({ videos: [...prev.videos, ...newItems] }));
                                            e.target.value = "";
                                        }}
                                    />
                                    <span className="icon text-30 text-dark mb-2 d-block">{"\uf03d"}</span>
                                    <div className="fw-bold text-dark text-14">{t("click_or_drag_video_here")}</div>
                                </div>
                                )}

                                {/* Preview Videos */}
                                <div className="d-flex flex-wrap gap-3 mb-3">
                                    {videos.map((vid, i) => (
                                        <div key={i} className="border rounded-3 p-2 position-relative bg-light" style={{ width: "200px" }}>
                                            {!view_mode && (
                                            <div
                                                className="position-absolute top-0 end-0 bg-danger text-white rounded-circle wpx-15 hpx-15 d-flex align-items-center justify-content-center pointer"
                                                style={{ transform: "translate(30%, -30%)", zIndex: 2 }}
                                                onClick={() => this.removeVideo(i)}
                                            >
                                                <span className="icon text-10">{"\uf00d"}</span>
                                            </div>
                                            )}
                                            <video
                                                src={vid.url}
                                                controls
                                                className="rounded-2 mb-1 w-100 bg-dark"
                                                style={{ height: "110px", objectFit: "contain" }}
                                            />
                                            <div className="text-10 text-secondary text-truncate fw-bold" title={vid.name}>{vid.name}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="mb-2">
                            <h6 className="fw-bold text-secondary mb-3">
                                <span className="icon me-2">{"\uf044"}</span> {t("admin_internal_note")}
                            </h6>
                            <textarea
                                className="form-control  text-14"
                                rows="3"
                                placeholder={t("internal_notes")}
                                value={create_internal_note}
                                onChange={(e) => this.setState({ create_internal_note: e.target.value })}
                            ></textarea>
                        </div>
                      </fieldset>
                    </Modal.Body>

                    <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-end gap-2">
                        <button className="btn btn-white border px-4 py-2" onClick={() => this.setState({ modal_create: false, ...this.getCreateFormState() })}>
                            {view_mode ? t("close") : t("cancel")}
                        </button>
                        {!view_mode && (
                            <button className="btn btn-primary px-4 py-2" onClick={this.CreateUpdate}>
                                + {t("create_request")}
                            </button>
                        )}
                    </Modal.Footer>
                </Modal>

                {/* ===================== Fast Call Modal ===================== */}
                <Modal
                    size="lg"
                    show={modal_fast_call}
                    onHide={() => this.setState({ modal_fast_call: false, fast_call_view_mode: false, ...this.getFastCallFormState() })}
                    centered
                    contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
                >
                    <Modal.Header className="bg-white p-4 border-bottom" closeButton>
                        <div className="w-100">
                            <h3 className="fw-bold mb-1 text-dark d-flex align-items-center">
                                <span className="icon me-2 text-dark">{"\uf095"}</span>
                                {fast_call_view_mode ? t("view_fast_call_info") : t("record_fast_call_result")}
                            </h3>
                            <div className="text-secondary text-14">
                                {active_request?.wr_number || "-"} • {this.getCustomerDisplayName(active_request?.customer)}
                            </div>
                            {/* Workflow Steps */}
                            <div className="d-flex w-100 overflow-auto mt-3" style={{ gap: "2px" }}>
                                <div
                                    className="bg-success text-white px-3 py-2 fw-bold text-12 rounded-start d-flex align-items-center position-relative flex-grow-1 justify-content-center"
                                    style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%)" }}
                                >
                                    <span className="icon me-1">{"\uf00c"}</span>
                                    <span className="">{t("wr_created")}</span>
                                </div>
                                <div
                                    className={`${
                                        active_request?.fast_call ? "bg-success text-white" : "bg-warning text-white border"
                                    } px-3 py-2 fw-bold text-12 d-flex align-items-center position-relative flex-grow-1 justify-content-center`}
                                    style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}
                                >
                                    {active_request?.fast_call ? <span className="icon me-1">{"\uf00c"}</span> : null}
                                    <span className="">{t("call_result_recorded")}</span>
                                </div>
                                <div
                                    className={`${
                                        active_request?.fast_call && active_request.status !== "rejected" ? "bg-success text-white" : "bg-light text-secondary border"
                                    } px-3 py-2 fw-bold text-12 rounded-end d-flex align-items-center position-relative flex-grow-1 justify-content-center`}
                                    style={{ clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}
                                >
                                    {active_request?.fast_call && active_request?.fast_call?.status === "success" ? <span className="icon me-1">{"\uf00c"}</span> : null}
                                    <span className="">
                                        {active_request?.fast_call && active_request?.fast_call?.status === "success"
                                            ? t("close_job")
                                            : active_request?.fast_call && active_request?.fast_call?.status === "pending_approval" && active_request.status !== "rejected"
                                            ? t("issue_wo")
                                            : t("close_job_or_issue_wo")}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="px-4 py-4 bg-white" style={{ maxHeight: "75vh", overflowY: "auto" }}>
                        <div className="rounded-3 border px-4 py-3 mb-4" style={{ backgroundColor: "#EFF6FF", borderColor: "#BFDBFE" }}>
                            <div className="text-primary fw-bold text-16">🔧 {active_request?.problem_description || "-"}</div>
                        </div>

                        <div className="mb-3 pb-2 border-bottom">
                            <div className="fw-bold text-secondary text-16">
                                <span className="icon me-2">{"\uf095"}</span>
                                {t("call_details")}
                            </div>
                        </div>

                        <div className="row g-3 mb-4">
                            <div className="col-md-6">
                                <label className="form-label text-dark fw-bold">
                                    {t("calling_technician")} <span className="text-danger">*</span>
                                </label>
                                <Select
                                    className="form-control"
                                    options={fastCallTechnicianOptions}
                                    value={fast_call_technician}
                                    placeholder={t("select_calling_technician")}
                                    onChange={(e) => this.setState({ fast_call_technician: e })}
                                    disabled={fast_call_view_mode}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label text-dark fw-bold">
                                    {t("call_datetime")} <span className="text-danger">*</span>
                                </label>
                                <div className="d-flex gap-2">
                                    <DatePicker
                                        type="th"
                                        className="form-control py-2"
                                        value={fast_call_date}
                                        onChange={(val) => this.setState({ fast_call_date: val })}
                                        disabled={fast_call_view_mode}
                                    />
                                    <input
                                        type="time"
                                        className="form-control py-2"
                                        style={{ maxWidth: "120px" }}
                                        value={fast_call_time}
                                        onChange={(e) => this.setState({ fast_call_time: e.target.value })}
                                        disabled={fast_call_view_mode}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label text-dark fw-bold">{t("call_duration_minutes")}</label>
                                <input
                                    type="text"
                                    className="form-control py-2"
                                    placeholder={t("eg_15_minutes")}
                                    value={fast_call_duration}
                                    onChange={(e) => this.setState({ fast_call_duration: e.target.value.replace(/\D/g, "") })}
                                    disabled={fast_call_view_mode}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label text-dark fw-bold">{t("call_channel_label")}</label>
                                <select className="form-select py-2" value={fast_call_channel} onChange={(e) => this.setState({ fast_call_channel: e.target.value })} disabled={fast_call_view_mode}>
                                    <option value="โทรศัพท์ตรง">{t("direct_phone_call")}</option>
                                    <option value="Line Call">Line Call</option>
                                    <option value="Video Call">Video Call</option>
                                </select>
                            </div>
                        </div>

                        <div className="mb-4">
                            <label className="form-label text-dark fw-bold">{t("customer_reported_symptom_summary")}</label>
                            <textarea
                                className="form-control py-3"
                                rows="4"
                                placeholder={t("call_detail_placeholder")}
                                value={fast_call_symptom}
                                onChange={(e) => this.setState({ fast_call_symptom: e.target.value })}
                                disabled={fast_call_view_mode}
                            ></textarea>
                        </div>

                        <div className="mb-4">
                            <label className="form-label text-dark fw-bold">
                                {t("recommended_solution_label")} <span className="text-danger">*</span>
                            </label>
                            <textarea
                                className="form-control py-3"
                                rows="4"
                                placeholder={t("solution_guidance_placeholder")}
                                value={fast_call_guidance}
                                onChange={(e) => this.setState({ fast_call_guidance: e.target.value })}
                                disabled={fast_call_view_mode}
                            ></textarea>
                        </div>

                        <div className="mb-3 pb-2 border-bottom">
                            <div className="fw-bold text-secondary text-16">{t("resolution_result_select_one")}</div>
                        </div>

                        <div className="row g-3">
                            <div className="col-md-6">
                                <div
                                    className={`rounded-4 border p-4 text-center pointer h-100 transition-hover ${fast_call_result === "closed" ? "shadow-sm" : ""}`}
                                    style={{
                                        borderWidth: fast_call_result === "closed" ? "3px" : "1px",
                                        borderColor: fast_call_result === "closed" ? "#059669" : "#D1FAE5",
                                        backgroundColor: fast_call_result === "closed" ? "#BBF7D0" : "#F0FDF4",
                                        boxShadow: fast_call_result === "closed" ? "0 0 0 5px rgba(16, 185, 129, 0.28), 0 14px 30px rgba(5, 150, 105, 0.18)" : "none",
                                        transform: fast_call_result === "closed" ? "translateY(-2px)" : "none",
                                        position: "relative",
                                    }}
                                    onClick={() => !fast_call_view_mode && this.setState({ fast_call_result: "closed" })}
                                >
                                    {fast_call_result === "closed" && (
                                        <div
                                            className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center text-white fw-bold"
                                            style={{
                                                width: "36px",
                                                height: "36px",
                                                backgroundColor: "#059669",
                                                borderBottomLeftRadius: "16px",
                                                borderTopRightRadius: "14px",
                                            }}
                                        >
                                            ✓
                                        </div>
                                    )}
                                    <div className="text-success text-40 mb-2">{fast_call_result === "closed" ? "✅" : "☑️"}</div>
                                    <div className="fw-bold text-success text-20 mb-2">{t("resolved_close_job")}</div>
                                    <div className="text-secondary">
                                        {t("customer_confirmed_normal_operation")}
                                        <br />
                                        {t("system_will_close_wo_as_phone_fix")}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div
                                    className={`rounded-4 border p-4 text-center pointer h-100 transition-hover ${fast_call_result === "visit" ? "shadow-sm" : ""}`}
                                    style={{
                                        borderWidth: fast_call_result === "visit" ? "3px" : "1px",
                                        borderColor: fast_call_result === "visit" ? "#2563EB" : "#BFDBFE",
                                        backgroundColor: fast_call_result === "visit" ? "#BFDBFE" : "#EFF6FF",
                                        boxShadow: fast_call_result === "visit" ? "0 0 0 5px rgba(59, 130, 246, 0.28), 0 14px 30px rgba(37, 99, 235, 0.18)" : "none",
                                        transform: fast_call_result === "visit" ? "translateY(-2px)" : "none",
                                        position: "relative",
                                    }}
                                    onClick={() => !fast_call_view_mode && this.setState({ fast_call_result: "visit" })}
                                >
                                    {fast_call_result === "visit" && (
                                        <div
                                            className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center text-white fw-bold"
                                            style={{
                                                width: "36px",
                                                height: "36px",
                                                backgroundColor: "#2563EB",
                                                borderBottomLeftRadius: "16px",
                                                borderTopRightRadius: "14px",
                                            }}
                                        >
                                            ✓
                                        </div>
                                    )}
                                    <div className="text-primary text-40 mb-2">{fast_call_result === "visit" ? "🔧" : "🛠️"}</div>
                                    <div className="fw-bold text-primary text-20 mb-2">{t("requires_onsite_visit")}</div>
                                    <div className="text-secondary">
                                        {t("cannot_resolve_by_phone")}
                                        <br />
                                        {t("system_will_create_onsite_wo_after_approval")}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-end align-items-center">
                        <div className="d-flex gap-2">
                            <button
                                className="btn btn-white border px-4 py-2 rounded-3 fw-bold"
                                onClick={() => this.setState({ modal_fast_call: false, fast_call_view_mode: false, ...this.getFastCallFormState() })}
                            >
                                {fast_call_view_mode ? t("close") : t("cancel")}
                            </button>
                            {!fast_call_view_mode && (
                                <button
                                    className="btn btn-primary px-4 py-2 rounded-3 fw-bold text-white"
                                    style={{
                                        backgroundColor: "#3B82F6",
                                        borderColor: "#3B82F6",
                                        opacity: fast_call_result ? 1 : 0.55,
                                        cursor: fast_call_result ? "pointer" : "not-allowed",
                                    }}
                                    onClick={this.submitFastCall}
                                    disabled={!fast_call_result}
                                >
                                    {!fast_call_result ? t("save_result") : fast_call_result === "closed" ? t("save_and_close_job") : t("save_result")}
                                </button>
                            )}
                        </div>
                    </Modal.Footer>
                </Modal>

                {/* ===================== APPROVE MODAL ===================== */}
                <Modal size="md" show={modal_approve} onHide={() => this.setState({ modal_approve: false })} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg">
                    <Modal.Header className="bg-white border-bottom px-4 py-3" closeButton>
                        <div className="d-flex align-items-center">
                            <div className="wpx-25 hpx-25 rounded-circle bg-success text-white d-flex align-items-center justify-content-center me-2">
                                <span className="icon text-12">{"\uf00c"}</span>
                            </div>
                            <h5 className="fw-bold mb-0 text-dark">{t("approve_work_request")}</h5>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="p-4 bg-white">
                        <div className="bg-light rounded-3 p-3 mb-4 d-flex justify-content-between align-items-start border ">
                            <div>
                                <div className="text-secondary text-12 mb-1">{t("request_id")}</div>
                                <h5 className="fw-bold text-dark mb-3">{active_request?.wr_number || ""}</h5>
                                <div className="text-secondary text-14">
                                    {t("customer_label")} <span className="text-dark fw-bold">{this.getCustomerDisplayName(active_request?.customer)}</span>
                                </div>
                                <div className="text-secondary text-14">
                                    {t("asset_label")} <span className="text-dark">{active_request?.asset?.part_name || ""}</span>
                                </div>
                            </div>
                            <span className="badge rounded-pill fw-bold px-3 py-1 text-12" style={this.getPriorityStyle(active_request?.priority?.name_th || "")}>
                                {active_request?.priority?.name_th || ""}
                            </span>
                        </div>

                        <div className="mb-3">
                            <label className="form-label text-14 text-dark fw-bold">{t("work_order_type")}</label>
                            <Select className="form-control" placeholder={t("select_req_category")} options={data_categories} value={create_category_id} disabled />
                        </div>

                        <div className="row g-3 mb-4">
                            <div className="col-md-6">
                                <label className="form-label text-14 text-dark fw-bold">{t("priority")}</label>
                                <Select className="form-control" placeholder={t("select_priority")} options={data_priorities} value={create_priority_id} disabled />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label text-14 text-dark fw-bold">{t("sla_template")}</label>
                                <input type="text" className="form-control" value={text_priority_id} disabled />
                            </div>
                        </div>

                        <div className="mb-4">
                            <label className="form-label text-14 text-dark fw-bold">{t("assign_technicians_optional")}</label>

                            <div className="border border-purple rounded-3 overflow-hidden">
                                <div className="bg-purple-light p-2 d-flex align-items-center border-bottom border-purple">
                                    <div className="wpx-25 hpx-25 rounded-circle bg-purple text-white d-flex align-items-center justify-content-center me-2">
                                        <span className="icon text-12">{"\uf040"}</span>
                                    </div>
                                    <span className="text-purple fw-bold me-2">{t("ai_recommended_technicians")}</span>
                                    <span className="badge bg-purple-light text-purple rounded-pill fw-normal text-10">{t("based_on_job_requirements")}</span>
                                </div>

                                <div className="p-3 bg-white">
                                    <div className="d-flex flex-column gap-3">
                                        {technicians.map((tech, idx) => (
                                            <div key={idx} className={`border rounded-3 p-3 position-relative ${tech.bestMatch ? "border-success bg-success-light-light" : " bg-white shadow-sm"}`}>
                                                {tech.bestMatch && (
                                                    <div className="position-absolute top-0 end-0 bg-success text-white px-2 py-1 text-10 fw-bold" style={{ borderBottomLeftRadius: "8px" }}>
                                                        <span className="icon me-1">{"\uf521"}</span> {t("best_match")}
                                                    </div>
                                                )}

                                                <div className="d-flex justify-content-between align-items-start mb-2">
                                                    <div className="d-flex align-items-center">
                                                        <div
                                                            className="wpx-40 hpx-40 rounded-circle text-white d-flex align-items-center justify-content-center fw-bold text-16 me-3"
                                                            style={{ backgroundColor: tech.bg }}
                                                        >
                                                            {tech.initials}
                                                        </div>
                                                        <div>
                                                            <div className="fw-bold text-dark text-16">{tech.name}</div>
                                                            <div className="text-secondary text-12 d-flex align-items-center">
                                                                <div className={`wpx-8 hpx-8 rounded-circle bg-${tech.statusColor} me-1`}></div>
                                                                <span className={`text-${tech.statusColor} fw-bold me-2`}>{tech.status}</span>
                                                                <span className="icon text-10 me-1">{"\uf041"}</span> {tech.distance}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button className={`btn btn-sm px-3 rounded-pill fw-bold ${tech.bestMatch ? "btn-success" : "btn-outline-primary bg-white"}`}>+ {t("add")}</button>
                                                </div>

                                                <div className="d-flex flex-wrap gap-2 mb-2">
                                                    {tech.tags.map((tag, tIdx) => (
                                                        <span key={tIdx} className={`badge bg-${tag.color}-light text-${tag.color} rounded-2 px-2 py-1 text-10 border border-${tag.color}`}>
                                                            <span className="icon me-1">{tag.icon}</span> {tag.text}
                                                        </span>
                                                    ))}
                                                </div>

                                                {tech.hint && (
                                                    <div className={`text-${tech.hintColor} text-12 fst-italic mt-2`}>
                                                        <span className="icon me-1">{tech.hintIcon}</span> {tech.hint}
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>

                                    <div className="text-center mt-3 pt-2 border-top">
                                        <a href="#" className="text-purple text-decoration-none fw-bold text-14">
                                            <span className="icon me-1">{"\uf0ca"}</span> {t("view_all_available_technicians")}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="text-secondary text-14">
                            {t("selected_technicians")} <span className="fst-italic">{t("none")}</span>
                        </div>

                        <div className="mt-4 pt-4 border-top">
                            <a href="#" className="text-secondary text-decoration-none text-14 d-block mb-3">
                                <span className="icon me-1">{"\uf054"}</span> {t("select_manually")}
                            </a>

                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("required_parts")}</label>
                            <div className="border rounded-3 p-3 mb-4">
                                <div className="form-check mb-2">
                                    <input className="form-check-input" type="checkbox" defaultChecked id="part1" />
                                    <label className="form-check-label text-dark text-14" htmlFor="part1">
                                        Compressor Motor 2HP (Qty: 1)
                                    </label>
                                </div>
                                <div className="form-check mb-2">
                                    <input className="form-check-input" type="checkbox" defaultChecked id="part2" />
                                    <label className="form-check-label text-dark text-14" htmlFor="part2">
                                        Refrigerant R-410A (Qty: 2kg)
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="part3" />
                                    <label className="form-check-label text-dark text-14" htmlFor="part3">
                                        Filter Drier (Qty: 1)
                                    </label>
                                </div>
                            </div>

                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("internal_notes")}</label>
                            <textarea className="form-control" rows="3" placeholder={t("add_notes_placeholder")}></textarea>
                        </div>
                    </Modal.Body>

                    <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-end gap-2">
                        <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_approve: false })}>
                            {t("cancel")}
                        </button>
                        <button className="btn btn-primary px-4 py-2 rounded-3 d-flex align-items-center fw-bold text-white shadow-sm" style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}>
                            <span className="icon me-2">{"\uf00c"}</span> {t("create_work_order")}
                        </button>
                    </Modal.Footer>
                </Modal>

                {/* ===================== REJECT MODAL ===================== */}
                <Modal size="md" show={modal_reject} onHide={() => this.setState({ modal_reject: false, reject_view_mode: false })} centered>
                    <Modal.Header className="bg-white px-4 pt-4 pb-0 border-0" closeButton>
                        <div className="d-flex align-items-center">
                            <span className="icon text-dark me-2 text-20 fw-bold">{"\uf00d"}</span>
                            <h4 className="fw-bold mb-0 text-dark">{reject_view_mode ? `${t("view")} ${t("reject_reason")}` : t("reject_work_request")}</h4>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="px-4 pb-2 pt-3 bg-white">
                        <div className="mb-2">
                            <label className="form-label text-dark fw-bold text-16">
                                {t("reject_reason")} {!reject_view_mode && <span className="text-danger">*</span>}
                            </label>
                            <Select
                                className="form-control"
                                placeholder={t("select_reject_reason")}
                                onChange={(e, i) => {
                                    this.setState({ reject_reason_id: e });
                                }}
                                value={reject_reason_id}
                                options={data_reject_reasons}
                                disabled={reject_view_mode}
                            />
                        </div>

                        <div className="mb-3 mt-3">
                            <label className="form-label text-dark fw-bold text-16">{t("additional_note")}</label>
                            <textarea
                                className="form-control py-2 "
                                rows="4"
                                placeholder={t("additional_notes")}
                                value={reject_note}
                                onChange={(e) => this.setState({ reject_note: e.target.value })}
                                disabled={reject_view_mode}
                            ></textarea>
                        </div>
                    </Modal.Body>

                    <Modal.Footer className="bg-white border-0 px-4 pb-4 pt-2 d-flex justify-content-end gap-2">
                        <button className="btn btn-white border px-4 py-2" onClick={() => this.setState({ modal_reject: false, reject_view_mode: false })}>
                            {reject_view_mode ? t("close") : t("cancel")}
                        </button>
                        {!reject_view_mode && (
                            <button className="btn btn-danger px-4 py-2" onClick={this.SubmitReject}>
                                {t("confirm_reject")}
                            </button>
                        )}
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}
